
import { Flex } from '@chakra-ui/react';
import  colors  from 'core/resources/theme/colors';



export default function HeaderTable(){
    return(
        <Flex bg={colors.black75} roundedTop={15} px={4} h='60px' align='center'>
            <Flex flex={1} fontWeight='medium'>Quantidade</Flex>
            <Flex flex={4} fontWeight='medium'>Item</Flex>
        </Flex>
    )
}